export default "__VITE_ASSET__ga1Ba_S8__"